import { IS_MAIN_COMPANY } from 'config'
import { ManageTickets } from 'pages/Tickets'
import { CreateTicket } from 'pages/Tickets/create'
import { ExternalTicketItem } from 'pages/Tickets/ExternalItem'
import { InternalTicketItem } from 'pages/Tickets/InternalItem'
import { lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { ProtectedRoutes } from './protected.route'

const AboutUs = lazy(() => import('pages/Base/AboutUs'))
const Careers = lazy(() => import('pages/Base/Careers'))
const ContactUs = lazy(() => import('pages/Base/ContactUs'))
const FAQs = lazy(() => import('pages/Base/FAQ'))
const Home = lazy(() => import('pages/Base/Home/Home'))
const HowItWorks = lazy(() => import('pages/Base/HowItWorks'))
const Investors = lazy(() => import('pages/Base/Investors'))
const Pricing = lazy(() => import('pages/Base/Pricing'))
const WhereWeLend = lazy(() => import('pages/Base/WhereWeLend'))

const ForgetPassword = lazy(() => import('pages/Auth/Login/ForgetPassword'))
const Login = lazy(() => import('pages/Auth/Login/Login'))
const Register = lazy(() => import('pages/Auth/Login/Register'))
const ResetPassword = lazy(() => import('pages/Auth/Login/ResetPassword'))
const SsoComplete = lazy(() => import('pages/Auth/Login/SsoComplete'))
const InstanceLogin = lazy(() => import('pages/Auth/Login/InstanceLogin'))

const LoanOverview = lazy(() => import('pages/LoanOverview'))
const BorrowerCreateLoan = lazy(() => import('pages/Borrower/CreateLoan/BorrowerCreateLoanByConfig'))
const BorrowerCreateLoanFinal = lazy(() => import('pages/Borrower/CreateLoan/BorrowerCreateLoanFinal'))

const Resources = lazy(() => import('pages/Resources'))
const GuidelineOverlay = lazy(() => import('pages/Resources/GuidelineOverlay'))
const AccountExecutivesEmbedPage = lazy(() => import('pages/Embed/AccountExecutivesPage'))
const LandingLearnMoreEmbedPage = lazy(() => import('pages/Embed/LandingLearnMorePage'))

export function BaseRoute() {
  return (
    <Switch>
      <Route exact path="/embed/account-executives">
        <AccountExecutivesEmbedPage />
      </Route>
      <Route exact path="/embed/landing-learn-more">
        <LandingLearnMoreEmbedPage />
      </Route>
      <Route exact path="/">
        {IS_MAIN_COMPANY ? <Home /> : <Redirect to="/login" />}
      </Route>
      <Route exact path="/about_us">
        <AboutUs />
      </Route>
      <Route exact path="/investors">
        <Investors />
      </Route>
      <Route exact path="/how_it_works">
        <HowItWorks />
      </Route>
      <Route exact path="/where_we_lend">
        <WhereWeLend />
      </Route>
      <Route exact path="/pricing">
        <Pricing />
      </Route>
      <Route exact path="/faqs">
        <FAQs />
      </Route>
      <Route exact path="/contacts">
        <ContactUs />
      </Route>
      <Route exact path="/careers">
        <Careers />
      </Route>
      <Route exact path="/resources">
        <Resources />
      </Route>
      <Route path="/guidelineOverlay/:documentId">
        <GuidelineOverlay />
      </Route>
      <Route exact path="/login">
        <Login />
      </Route>
      <Route exact path="/register">
        <Register />
      </Route>
      <Route exact path="/register/:id">
        <Register />
      </Route>
      {/*
        Not under /auth/: the CDN proxies /auth/* to the tenant API on every host, so a route there
        never reaches this app - the browser gets Nest's "Cannot GET" instead. Must stay in step
        with SPA_COMPLETE_PATH in the backend's sso.controller.ts.
      */}
      <Route exact path="/sso/complete">
        <SsoComplete />
      </Route>
      {/*
        Same CDN rule as /sso/complete: admin.nexys.com opens this path with a one-time code.
        Backend mint URL must stay in step (InstanceLoginService.createHandoff).
      */}
      <Route exact path="/instance-login">
        <InstanceLogin />
      </Route>
      <Route exact path="/forgetPassword">
        <ForgetPassword />
      </Route>
      <Route exact path="/resetPassword/:selector/:token">
        <ResetPassword />
      </Route>
      <Route exact path="/loan_process/structure/new">
        <LoanOverview />
      </Route>
      <Route exact path="/loan_process/structure/new/:token/:id">
        <LoanOverview />
      </Route>
      <Route exact path="/newpa/:loan_number" key={14}>
        <BorrowerCreateLoanFinal />
      </Route>
      <Route exact path="/new/:aeName" key={12}>
        <BorrowerCreateLoan />
      </Route>
      <Route exact path="/new" key={13}>
        <BorrowerCreateLoan />
      </Route>
      <Route exact path="/tickets">
        <ManageTickets />
      </Route>
      <Route exact path="/tickets/internal/:id">
        <InternalTicketItem />
      </Route>
      <Route exact path="/tickets/external/:id">
        <ExternalTicketItem />
      </Route>
      <Route exact path="/create-ticket">
        <CreateTicket />
      </Route>
      <ProtectedRoutes />
    </Switch>
  )
}
